var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiBetslip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.958393 4.15761C0.0443309 4.72011 -0.272075 5.91542 0.255268 6.82949L6.12636 17.0248C6.65371 17.9389 7.84902 18.2553 8.79824 17.7279L15.5834 13.8256C16.5326 13.2631 16.849 12.0678 16.2865 11.1537L10.4154 0.958393C9.88808 0.0443309 8.69277 -0.272075 7.74355 0.255268L0.958393 4.15761ZM16.1459 14.7748L11.3998 17.517C11.7162 17.8334 12.1732 17.974 12.6654 17.974H20.5404C21.5951 17.974 22.5092 17.0951 22.5092 16.0053V4.19277C22.5092 3.13808 21.5951 2.22402 20.5404 2.22402H12.6654C12.5951 2.22402 12.5248 2.25917 12.4545 2.25917L17.2709 10.5912C18.1146 12.0326 17.6225 13.931 16.1459 14.7748Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBetslip);
export default ForwardRef;